<template>
	<div class="eu-energy-label" :class="[classLabel, align]">
		<span class="eu-energy-label-class">
			{{ splitHdnValue(energyLabel)[1] }}
		</span>
		<svg
			viewBox="0 0 100 223"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="label-triangle"
		>
			<g>
				<path
					d="M0.249994 111.5L100 0.215724L100 222.784L0.249994 111.5Z"
					style="fill: var(--energy-label-color)"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { splitHdnValue } from "@/helpers/hdnHelpers";
import type { EnergieLabel } from "@loanlink-nl/model-app";

const props = withDefaults(
	defineProps<{ energyLabel: EnergieLabel; align?: "start" | "end" }>(),
	{
		align: "start",
	},
);

const classLabel = computed(() => {
	const labelCode = splitHdnValue(props.energyLabel)[0];

	switch (labelCode) {
		case "01":
		case "02":
		case "03":
		case "10":
		case "11":
		case "14":
			return "a";
		case "04":
			return "b";
		case "05":
			return "c";
		case "06":
			return "d";
		case "07":
			return "e";
		case "08":
			return "f";
		case "09":
			return "g";
		default:
			return "";
	}
});
</script>

<style lang="scss">
.eu-energy-label {
	--label-a: #009037;
	--label-b: #55ab26;
	--label-c: #c8d100;
	--label-d: #ffec00;
	--label-e: #faba00;
	--label-f: #eb6909;
	--label-g: #e2001a;

	--label-appppp: var(--label-a);
	--label-apppp: var(--label-a);
	--label-appp: var(--label-a);
	--label-app: var(--label-a);
	--label-ap: var(--label-a);

	--energy-label-color: #aaa;

	--energy-label-text: #fff;

	text-transform: capitalize;
	color: white;
	font-weight: 500;
	display: flex;
	align-items: stretch;
	position: relative;
	height: 2em;

	&.appppp {
		--energy-label-color: var(--label-appppp);
	}

	&.apppp {
		--energy-label-color: var(--label-apppp);
	}

	&.appp {
		--energy-label-color: var(--label-appp);
	}

	&.app {
		--energy-label-color: var(--label-app);
	}

	&.ap {
		--energy-label-color: var(--label-ap);
	}

	&.a {
		--energy-label-color: var(--label-a);
	}

	&.b {
		--energy-label-color: var(--label-b);
	}

	&.c {
		--energy-label-color: var(--label-c);
		--energy-label-text: #000;
	}

	&.d {
		--energy-label-color: var(--label-d);
		--energy-label-text: #000;
	}

	&.e {
		--energy-label-color: var(--label-e);
		--energy-label-text: #000;
	}

	&.f {
		--energy-label-color: var(--label-f);
	}

	&.g {
		--energy-label-color: var(--label-g);
	}

	.eu-energy-label-class {
		background: var(--energy-label-color);
		color: var(--energy-label-text);
		padding: 0.25em;
		padding-left: 0.5em;
		flex: 1;
		text-align: start;
	}

	.label-triangle {
		aspect-ratio: 100/223;
		height: 100%;
		transform: scale(-1, 1);
		flex-basis: fit-content;
	}

	&.end {
		flex-direction: row-reverse;

		.eu-energy-label-class {
			padding-left: 0.25em;
		}

		.label-triangle {
			transform: unset;
		}
	}
}
</style>
